<template>
	<div class="eia-app">
		<eia-page-header></eia-page-header>
		<main v-if="this.$store.state.ready"
			class="eia-page-boundary-container">
			<router-view></router-view>
		</main>
		<eia-page-footer></eia-page-footer>
		<eia-loading v-if="this.$store.state.loading"></eia-loading>
	</div>
</template>

<script>
import { get } from '@/utils/api-utils';
import { to } from '@/utils/promise-utils';
import { mapState } from 'vuex';

export default {

	name: 'App',

	computed: mapState( [ 'bootstrap' ] ),

	watch: {

		// watch bootstrap and wait for it to complete
		bootstrap( val ){

			// already bootstrapped
			if( this.$store.state.ready ){
				return;
			}

			for( const v of Object.values( val ) ){
				if( v === null ){
					return;
				}
			}

			this.$store.commit( 'setReady' );
			this.$store.commit( 'clearLoading' );
		},
	},

	methods: {

		async getProposals(){
			const [ err, response ] = await to(
				get( 'proposals' )
			);

			if( !err ){

				this.$store.commit( 'setProposalsLoaded' );
				this.$store.commit( 'setProposals', response );

			}
		},

	},

	mounted() {

		this.getProposals();

	},

};
</script>

<style lang="scss" scoped>
.eia-app {
	display: flex;
	flex-direction: column;
	min-height: 100%;
}


.eia-page-header {
	position: relative;
	z-index: 10;
}

.eia-page-boundary-container {
	position: relative;
	z-index: 1;
	padding-top: 24px;
	padding-bottom: 24px;
	display: block;
}
</style>
